/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_QueuedInputs */

const cs_property_legal_queued = /** @type {(inputs: Property_Legal_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právní dokument zařazen do fronty`)
};

const en_property_legal_queued = /** @type {(inputs: Property_Legal_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal document queued`)
};

/**
* | output |
* | --- |
* | "Legal document queued" |
*
* @param {Property_Legal_QueuedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_queued = /** @type {((inputs?: Property_Legal_QueuedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_QueuedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_queued(inputs)
	return cs_property_legal_queued(inputs)
});